import { FALLBACK_IMAGE_SM, LazyImage } from "@website/ui/lazy-image";
import { deepCompare } from "@website/utils/deep-compare";
import { ReserveCommentPicturesTypes } from "@website/widget/reserve-comment/reserve-comment-pictures/reserve-comment-pictures.types";
import { useRouter } from "next/router";
import { memo, useCallback } from "react";

const Component = ({ id, gallery }: ReserveCommentPicturesTypes) => {
  const router = useRouter();
  const openModalCondition = "gallery-comment";

  const onClick = useCallback(
    (item: string, id: number) =>
      router.push(
        {
          pathname: router.pathname,
          query: { ...router.query, modal: openModalCondition, item, id }
        },
        undefined,
        { shallow: true, scroll: false }
      ),
    [router]
  );
  return (
    <div className="flex flex-row flex-wrap justify-start gap-4">
      {gallery.map((picture, index) => (
        <LazyImage
          className="h-[60px] w-[74px] cursor-pointer rounded-lg"
          fallback={FALLBACK_IMAGE_SM.src}
          id={String(picture?.id)}
          onClick={() => onClick(String(index), id)}
          src={picture?.media}
        />
      ))}
    </div>
  );
};

export const ReserveCommentPictures = memo(Component, deepCompare);
